import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import authService from './authService';
import './css/LoginRegForm.css';
import logo from './images/logo_nqtb.png';
import Footer from '../lab/Footer';

const ForgotPassword = () => {
  const [email, setEmail] = useState('');
  const [message, setMessage] = useState('');
  const [error, setError] = useState(false);
  const [success, setSuccess] = useState(false);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleSubmit = (e) => {
    e.preventDefault();
    setLoading(true);
    setMessage('');
    setError(false);
    setSuccess(false);

    authService.requestPasswordReset(email)
      .then(() => {
        setSuccess(true);
        setMessage('Password reset email has been sent. Please check your inbox.');

        // Reset form
        setEmail('');

        // Redirect to login page after a delay
        setTimeout(() => {
          navigate('/login', {
            state: {
              message: 'Password reset email has been sent. Please check your inbox.',
              messageType: 'success'
            }
          });
        }, 3000);
      })
      .catch(error => {
        setError(true);
        setMessage(error.message || 'An error occurred while requesting password reset');
      })
      .finally(() => {
        setLoading(false);
      });
  };

  return (
    <div className='logreg-back'>
      <div className="box-con">
        <div className="box">
          <div className="upper-part">
            <img className="logo" src={logo} alt="logo" />
          </div>
          <div className="tab-container">
            <Link
              to="/login"
              className="tab right-disp ">
              Log in
            </Link>
            <Link
              to="/register"
              className="tab right-disp ">
              Sign up
            </Link>
          </div>

          <form className="form" onSubmit={handleSubmit}>
            <div className='form-wrapper'>

              {message && (
                <div className="message-group"
                  style={{ backgroundColor: error ? 'rgb(221, 167, 164)' : success ? 'rgb(167, 221, 164)' : 'transparent' }}>
                  <div className="svg-div-first">
                    {error ? (
                      <svg style={{ color: 'rgb(213, 129, 161)' }} xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-exclamation-circle-fill" viewBox="0 0 16 16">
                        <path d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0M8 4a.905.905 0 0 0-.9.995l.35 3.507a.552.552 0 0 0 1.1 0l.35-3.507A.905.905 0 0 0 8 4m.002 6a1 1 0 1 0 0 2 1 1 0 0 0 0-2" />
                      </svg>
                    ) : success ? (
                      <svg style={{ color: 'rgb(129, 213, 161)' }} xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-check-circle-fill" viewBox="0 0 16 16">
                        <path d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0m-3.97-3.03a.75.75 0 0 0-1.08.022L7.477 9.417 5.384 7.323a.75.75 0 0 0-1.06 1.06L6.97 11.03a.75.75 0 0 0 1.079-.02l3.992-4.99a.75.75 0 0 0-.01-1.05z" />
                      </svg>
                    ) : null}
                  </div>
                  <p className="message">{message}</p>
                </div>
              )}

              <p className="forgot-pass-p">
                Enter your email address and we'll send you a link to reset your password.
              </p>
              <div className="form-group form-first-fp forgot-form">
                <div className="svg-div">
                  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-envelope-fill" viewBox="0 0 16 16">
                    <path d="M.05 3.555A2 2 0 0 1 2 2h12a2 2 0 0 1 1.95 1.555L8 8.414zM0 4.697v7.104l5.803-3.558zM6.761 8.83l-6.57 4.027A2 2 0 0 0 2 14h12a2 2 0 0 0 1.808-1.144l-6.57-4.027L8 9.586zm3.436-.586L16 11.801V4.697z" />
                  </svg>
                </div>
                <div className="username-form">
                  <input
                    type="email"
                    name="email"
                    placeholder="Email"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    required
                  />
                </div>
              </div>
            </div>
            <div>
              <div className='button-wrap'>
                <button
                  className="login-but"
                  type="submit"
                  disabled={loading}
                >
                  {loading ? 'SENDING...' : 'SEND RESET LINK'}
                </button>
              </div>
            </div>
          </form>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default ForgotPassword;
